module.exports = __webpack_public_path__ + "img/logo.3de71ea5.png";